import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { FAQS } from '../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-sand py-20 sm:py-24" data-id="element-69" data-mp="1gcxqqlftt40b">
      <div className="mx-auto max-w-3xl px-5" data-id="element-70" data-mp="1geimgedvmszr">
        <Reveal className="text-center" data-id="element-71" data-mp="2e06aoc06i507">
          <p className="text-sm font-semibold uppercase tracking-widest text-clay" data-id="element-72" data-mp="2dzxuaa4ukhk9">
            Preguntas frecuentes
          </p>
          <h2 className="mt-3 font-serif text-3xl font-semibold text-ink sm:text-4xl" data-id="element-73" data-mp="28zijnqby9o5z">
            Todo lo que necesitás saber antes de entrar
          </h2>
        </Reveal>

        <div className="mt-10 space-y-3" data-id="element-74" data-mp="1z2xcaycgk0yz">
          {FAQS.map((faq, i) => {
          const isOpen = open === i;
          return <Reveal key={faq.question} delay={i * 0.03} data-id="element-75" data-mp="noa1keryhuhh" data-mpi={i}>
                <div className="overflow-hidden rounded-xl border border-sand bg-cream" data-id="element-76" data-mp="nmp4oii65zgg">
                  <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left" data-id="element-77" data-mp="pih762d1szrk">
                    <span className="font-medium text-ink" data-id="element-78" data-mp="kil548nwvien">{faq.question}</span>
                    <motion.span animate={{
                  rotate: isOpen ? 45 : 0
                }} transition={{
                  duration: 0.2
                }} className="flex-shrink-0 text-sage-deep" data-id="element-79" data-mp="kko0z9bqw5ra">
                      <PlusIcon className="h-5 w-5" data-id="element-80" data-mp="3szfwaqvcjecw" />
                    </motion.span>
                  </button>
                  <AnimatePresence initial={false} data-id="element-81" data-mp="1terv15vzj08">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.25,
                  ease: 'easeInOut'
                }} data-id="element-82" data-mp="3jxq7lssumtit">
                        <p className="px-5 pb-4 text-sm leading-relaxed text-muted" data-id="element-83" data-mp="1ppckj4yp2540">
                          {faq.answer}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}